import React from "react";
import AppointeeBankDetails from "./appointee/bank";
import AppointeePersonalDetails from "./appointee";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorMessage from "../partials/error";
import NomineeDetails from "./details";
import SectionTitle from "../../../components/sectionTitle";
import {
  Backdrop,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import {
  isNomineeMinor,
  isNomineeProceedButtonDisabled,
} from "../../../helpers/nominee";
import { BUTTON_PROCEED } from "../../../constants";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function NomineeAppointeeDetailsForm({
  classes: { container, containerButton, main },
  backdrop,
  banks,
  dateRange,
  errorMessage,
  errors,
  form,
  handleAccordionChange,
  handleBack,
  handleChange,
  handleCheckboxChange,
  handleChangeChipSelect,
  isFormSubmitted,
  modal,
  options,
  onSubmit,
  section,
  selectedBankOption1,
  setSelectedBankOption1,
  selectedBankOption2,
  setSelectedBankOption2,
  validateInputLength,
}) {
  return (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1}>
          <SectionTitle
            title={"Application Form Details"}
            onClickHandler={handleBack}
          />
        </Box>

        <Box className={container}>
          <form noValidate autoComplete="off" onSubmit={onSubmit}>
            <Box direction="column" style={{ width: "100%" }}>
              <NomineeDetails
                banks={banks}
                dateRange={dateRange}
                errorMessage={errorMessage}
                form={form}
                handleAccordionChange={handleAccordionChange}
                handleChange={handleChange}
                handleChangeChipSelect={handleChangeChipSelect}
                options={options}
                section={section}
                selectedBankOption={selectedBankOption1}
                setSelectedBankOption={setSelectedBankOption1}
                validateInputLength={validateInputLength}
              />

              {form.nominee_dob && form.nominee_age < 18 && (
                <>
                  <AppointeePersonalDetails
                    dateRange={dateRange}
                    errorMessage={errorMessage}
                    form={form}
                    handleAccordionChange={handleAccordionChange}
                    handleChange={handleChange}
                    handleChangeChipSelect={handleChangeChipSelect}
                    options={options}
                    section={section}
                    validateInputLength={validateInputLength}
                  />

                  <AppointeeBankDetails
                    banks={banks}
                    errorMessage={errorMessage}
                    form={form}
                    handleAccordionChange={handleAccordionChange}
                    handleChange={handleChange}
                    handleChangeChipSelect={handleChangeChipSelect}
                    options={options}
                    section={section}
                    selectedBankOption={selectedBankOption2}
                    setSelectedBankOption={setSelectedBankOption2}
                    validateInputLength={validateInputLength}
                  />
                </>
              )}
            </Box>

            {1 === 1 && (
              <Box
                className={containerButton}
                sx={{ backgroundColor: "#ffffff" }}
              >
                <ErrorMessage errors={errors} modal={modal} />
                <Box mb={1} sx={{ textAlign: "left" }}>
                  <FormControlLabel
                    control={
                      <Box style={{ alignSelf: "start" }}>
                        <Checkbox
                          checked={form.declaration}
                          onChange={handleCheckboxChange}
                          name={"declaration"}
                          color="primary"
                          disabled={true}
                        />
                      </Box>
                    }
                    label={
                      <Box mt={1}>
                        <Typography variant="caption">
                          {isNomineeMinor(form.nominee_age)
                            ? "Nominee & Appointee"
                            : "Nominee"}{" "}
                          address same as Life Insured
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
                <CallToAction
                  buttonType={"submit"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={
                    isFormSubmitted ||
                    isNomineeProceedButtonDisabled(
                      form,
                      errorMessage,
                      selectedBankOption1,
                      selectedBankOption2
                    )
                  }
                  isFormSubmitted={isFormSubmitted}
                  text={BUTTON_PROCEED}
                />
              </Box>
            )}
          </form>
        </Box>
      </Box>

      <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          sx={{ width: "100%" }}
          textAlign="center"
        >
          <Typography variant="body1">
            Processing request, please wait.
          </Typography>
          <Box mt={2}>
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      </Backdrop>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  NomineeAppointeeDetailsForm
);
